import React from "react";
import { DocsThemeConfig } from "nextra-theme-docs";
import { useRouter } from "next/router";
import { useConfig } from "nextra-theme-docs";

const config: DocsThemeConfig = {
  logo: <span>pocko-ui</span>,
  project: {
    link: "https://github.com/chennkaibin/pocko-ui",
  },
  head: () => {
    const { asPath, defaultLocale, locale } = useRouter();
    const { frontMatter } = useConfig();

    const url =
      "https://chennkaibin.github.io" +
      (defaultLocale === locale ? asPath : `/${locale}${asPath}`);

    return (
      <>
        <meta property="og:url" content={url} />
        <meta property="og:title" content={frontMatter.title || "Pocko UI"} />
        <meta
          property="og:description"
          content={frontMatter.description || "Pocko UI"}
        />
      </>
    );
  },
  footer: {
    text: "©2026 Pocko-UI",
  },
  editLink: {
    text: "",
  },
  feedback: {
    useLink: () => "https://github.com/chennkaibin/pocko-ui/issues/new",
  },
  useNextSeoProps() {
    const { asPath } = useRouter();
    if (asPath !== "/") {
      return {
        titleTemplate: "%s – Pocko UI",
      };
    } else {
      return {
        titleTemplate: "Pocko UI",
      };
    }
  },
  sidebar: {
    defaultMenuCollapseLevel: 1,
  },
};

export default config;
